import React from 'react';
import { WalletIcon, ClockIcon, UsersIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhyOfriV2() {
  const benefits = [{
    icon: WalletIcon,
    title: 'Clever sparen',
    description: 'Wer vergleicht, zahlt weniger. Bis zu 40% günstiger.'
  }, {
    icon: ClockIcon,
    title: 'In 2 Minuten erledigt',
    description: 'Beschreiben Sie Ihr Projekt, den Rest übernehmen wir.'
  }, {
    icon: UsersIcon,
    title: 'Mehrere Offerten',
    description: 'Geprüfte lokale Fachbetriebe kontaktieren Sie mit ihren besten Offerten.'
  }];
  return <section className="py-14 sm:py-20 bg-gray-50" data-id="element-81">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <motion.h2 initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-10 sm:mb-16 tracking-tight" data-id="element-83">
          Warum Ofri?
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-8 md:gap-6" data-id="element-84">
          {benefits.map((b, i) => <motion.div key={b.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="text-center" data-id="element-85">
              <b.icon className="w-12 h-12 text-ofri-blue mx-auto mb-5" strokeWidth={1.75} data-id="element-86" />
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-87">
                {b.title}
              </h3>
              <p className="text-gray-600 leading-relaxed max-w-xs mx-auto" data-id="element-88">
                {b.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}